export default "__VITE_ASSET__ccb26714__"